import React, { Component } from 'react';
import Inventory from './Inventory';
import sampleFishes from '../sample-fishes';
import base from '../base';
import PropTypes from 'prop-types';

class Admin extends Component {
  state = {
    fishes: {},
    order: {}
  };

  static propTypes = {
    match: PropTypes.object
  };

  componentDidMount(){
    const params = this.props.match.params.storeId;
    const localStorageRef = localStorage.getItem(params)
    if(localStorageRef){
      this.setState({ order: JSON.parse(localStorageRef) });
    }
    this.ref = base.syncState(`${params}/fishes`, {
      context: this,
      state: 'fishes'
    });
  };

  componentWillUnmount(){
    base.removeBinding(this.ref);
  };

  addFish = (fish) => {
    const fishes = { ...this.state.fishes };
    fishes[`fish${Date.now()}`] = fish;
    this.setState({
      fishes: fishes
    });
  };

  updateFish = (key, updatedFish) => {
    const fishes = {...this.state.fishes};
    fishes[key] = updatedFish;
    this.setState({ fishes: fishes});
  };

  deleteFish = (key) => {
    const fishes = { ...this.state.fishes};
    fishes[key] = null;
    this.setState({ fishes: fishes });
  };

  loadSampleFishes = () => {
    this.setState({ fishes: sampleFishes });
  };

  render(){
    return(
      <div>
        <div>We are on the admin page</div>
        <div className="catch-of-the-day">
          <Inventory
            addFish={this.addFish}
            updateFish={this.updateFish}
            deleteFish={this.deleteFish}
            loadSampleFishes={this.loadSampleFishes}
            fishes={this.state.fishes}
            storeId={this.props.match.params.storeId}
            history={this.props.history} />
        </div>
      </div>
    );
  }
}

export default Admin;



// WEBPACK FOOTER //
// ./src/components/Admin.js